import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useAddressByBodyshopReducer = () =>
  useSelector((state: ApplicationState) => state.addressByBodyshop);
